import SubscriptionHighlightWrapper from './components/SubscriptionHighlightWrapper';
export default SubscriptionHighlightWrapper;